import { DesignReferencesCountResult } from "./useDesignReferencesCount";

export const useApiServiceDesignReferencesCount = (
  designId: string
): DesignReferencesCountResult => {
  //For API service we do not show and have any references
  return { total: 0 };
};
